import React from 'react'

const DealSauceAIBanner = () => {
  const [isVisible, setIsVisible] = React.useState(false)

  React.useEffect(() => {
    try {
      const host = window.location.hostname
      const token = localStorage.getItem('token')
      const dismissed =
        localStorage.getItem('dealsauce-ai-banner-dismissed') === '1'
      if (
        (host === 'old.dealsauce.io') &&
        token &&
        !dismissed
      ) {
        setIsVisible(true)
      }
    } catch (e) {
      // no-op
    }
  }, [])

  const handleDismiss = React.useCallback(() => {
    try {
      localStorage.setItem('dealsauce-ai-banner-dismissed', '1')
    } catch (e) {
      // no-op
    }
    setIsVisible(false)
  }, [])

  if (!isVisible) return null

  return (
    <div
      id="dealsauce-ai-banner"
      role="status"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2147483647,
        background: '#111827',
        color: '#ffffff',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
        fontSize: 14,
        lineHeight: 1.4,
        padding: '12px 48px 12px 16px',
        textAlign: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      }}
    >
      <span>
        Got questions about how to use Deal Sauce? Try our NEW AI chat
        bot at the bottom right of your screen to get expert help.
      </span>
      <button
        aria-label="Dismiss notification"
        onClick={handleDismiss}
        style={{
          position: 'absolute',
          top: '50%',
          right: 12,
          transform: 'translateY(-50%)',
          background: 'transparent',
          border: 'none',
          color: '#ffffff',
          fontSize: 18,
          cursor: 'pointer',
        }}
      >
        ×
      </button>
    </div>
  )
}

export default DealSauceAIBanner
